<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/documents">Documents</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-2">
              <b-row>
                <b-col md="12">
                  <b-row>
                    <b-col md="5">
                      <label class="labels">name *</label>
                      <div class="form-group" v-bind:class="errors.has('name') ? 'has-error':''">
                        <input type="text" class="form-control" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'" data-vv-as="name" name="name" v-model="model.name" placeholder="Enter Name" />
                        <p v-if="errors.has('name') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">category *</label>
                      <div class="form-group" v-bind:class="errors.has('category') ? 'has-error':''">
                        <b-form-select name="category" v-model="model.category" v-bind:class="errors.has('category') ? 'is-invalid':''" :error="errors.first('category')" :options="categoryList" placeholder="category">
                        </b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">Customer *</label>
                      <div class="form-group" v-bind:class="errors.has('customer') ? 'has-error':''">
                        <b-form-select name="customer" v-model="model.customer" v-bind:class="errors.has('customer') ? 'is-invalid':''" :error="errors.first('customer')" :options="customerList" placeholder="customer">
                        </b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">Upload File * </label>
                      <b-form-group label-size="sm">
                        <b-form-file size="sm"></b-form-file>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">note </label>
                      <div class="form-group" v-bind:class="errors.has('note') ? 'has-error':''">
                        <b-form-textarea rows="3" class="form-control" v-bind:class="errors.has('note') ? 'is-invalid':''" data-vv-as="note" name="note" v-model="model.note" placeholder="Enter Note" />
                        <p v-if="errors.has('note') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-button class="mr-2" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
              </div>
            </form>
        </b-card>
    </div>
</template>

<script>
  export default {
    name: 'document-form',
    data () {
      return {
        isLoading: false,
        apiUrl: {
          document: window.AppConfig.apiUrl + 'document',
        },
        model: {
          name: '',
          note: '',
          customer: '',
          category: '',
        },
        categoryList: [
          {
            value: '',
            text: 'Please Select Category'
          },
          {
            value: 'QRT',
            text: 'QRT'
          },
          {
            value: 'SIR',
            text: 'SIR'
          },
          {
            value: 'Live Report',
            text: 'LIVE REPORT'
          },
          {
            value: 'CM/PM/Hardening',
            text: 'CM/PM/HARDENING'
          },
          {
            value: 'Ticketing (Open Ticket)',
            text: 'TICKETING (OPEN TICKET)'
          },
        ],
        customerList: [
          {
            value: '',
            text: 'Please Select Customer'
          }
        ]
      }
    },
    mounted() {
      this.getCustomer()
    },
    methods: {
      getCustomer () {
        this.$http.get(window.AppConfig.apiUrl + 'customer').then(response => {
          this.customerList = [
            {
              value: '',
              text: 'Please Select Customer'
            }
          ]
          response.data._embedded.customer.forEach(data => {
            this.customerList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm A')
        } else {
          return '-'
        }
      },
      goBack () {
        window.goBack(this)
      },
      getStatusColor (val) {
        switch (parseInt(val)) {
        case 0:
          return 'success'
          break
        case 1:
          return 'info'
          break
        }
      },
      // doSubmit () {
      //   this.$validator.validateAll().then(res => {
      //     if (res) {
      //       if (this.$route.params.id !== undefined) {
      //         this.$http.patch(this.apiUrl.company + '/' + this.$route.params.id, this.model).then(response => {
      //           this.$store.dispatch('notification/success', 'Company has been updated.')
      //           window.location.href = document.URL.replace('/edit', '')
      //         }).catch(error => {
      //           this.$store.dispatch('notification/error', error)
      //         })
      //       } else {
      //         this.$http.post(this.apiUrl.company, this.model).then(response => {
      //           this.$store.dispatch('notification/success', 'Company has been added.')
      //           window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
      //         }).catch(error => {
      //           this.$store.dispatch('notification/error', error)
      //         })
      //       }
      //     } else {
      //       swal("", "Please fill the required fields!", "info", {
      //         buttons: false,
      //         timer: 2000
      //       });
      //     }
      //   })
      // },
    }
  }
</script>